import { publicVisionLabApi } from '@/app/apiClient';
import type { LoginFinalizeResponse } from '@/features/authentication/types/accountAccess';
import {
  type PasswordRecoveryReceipt,
  passwordRecoveryInputSchema,
} from '@/features/authentication/types/passwordRecovery';
import { type CommandOptions, commandOptions } from '@/shared/api/command';

// This command may return EMAIL_NOT_VERIFIED as a recoverable login-completion outcome. Use an
// explicit captured bearer token, without the ordinary client's session-expired navigation callback.
export function finalizeLogin(
  idToken: string,
  invitationToken: string | undefined,
  options: CommandOptions,
): Promise<LoginFinalizeResponse> {
  return publicVisionLabApi.post<LoginFinalizeResponse>('/me/login/finalize', {
    ...commandOptions(options),
    headers: { ...commandOptions(options).headers, Authorization: `Bearer ${idToken}` },
    json: invitationToken ? { invitationToken } : {},
  });
}

export function requestPasswordRecovery(email: string, options: CommandOptions) {
  return publicVisionLabApi.post<PasswordRecoveryReceipt>('/password-recoveries', {
    ...commandOptions(options),
    json: passwordRecoveryInputSchema.parse({ email }),
  });
}
